import styled from '@emotion/styled';

/**
 * Sits around the DS footer, which accepts only a `className`. It carries the three things that
 * therefore cannot go on the `<footer>` itself: `data-elastic-exclude`, the promotion observer's
 * ref, and the `margin-top: auto` that keeps the footer at the bottom of a short page.
 */
export const FooterOuter = styled.div`
  margin-top: auto;
`;
